import React from 'react'
import { connect } from 'react-redux';
import TransferCardHeader from './TransferCardHeader';
import KeyItem from './KeyItem';
import LostKey from './LostKey';
import ConfirmDialog from './common/confirmDialog';
import actions from '../actions/index';
import { getHref } from '../helpers/AbloyKeyHelper';
import '../src/transferCard.scss';

const mapStateToProps = state => {
  return {
    abloyKeys   : state.abloyKeys,
    receivedKeys: state.receivedKeys,
    lostKeys    : state.lostKeys,
    brokenKeys  : state.brokenKeys,
  }
};

const mapDispatchToProps = dispatch => ({
  addLeaseKey: (leaseId, stamp) => dispatch(actions.addLeaseKey(leaseId, stamp)),
});

class TransferOutCard extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      params: {}
    }
  }

  /* computed */
  cardHeader() {
    const leaseId = this.props.transfer.old_lease_id;
    const href = getHref(leaseId);

    return (
      <div className="card-title">
        <i className='fa fa-arrow-left' />POISMUUTAVAT
        {href ? <a className="small-ghost-button" href={href}><i className="fa fa-key"></i>Avaimet</a> : null}
      </div>
    )
  }

  loadedAbloyKeys() {
    const primaryCustomers = this.props.transfer.old_lease.primary_customers;
    const abloyKeys = lodash.filter(this.props.abloyKeys, key => {
      return lodash.find(primaryCustomers, (customer) => {
        let abloyCustomerIdentity = 'loas-' + customer.id
        if (customer.abloy_customer) {
          abloyCustomerIdentity = customer.abloy_customer.identity
        }
        return key.key_holder_identity == abloyCustomerIdentity
      })
    });

    if (abloyKeys.length == 0) {
      return
    }
    const receivedKeysStamps = lodash.map(this.props.receivedKeys, 'stamp');
    const filteredAbloyKeys  = lodash.filter(abloyKeys, abloykey => {
      return !lodash.includes(receivedKeysStamps, abloykey.marking)
    });
    const leaseId = this.props.transfer.old_lease_id
    return filteredAbloyKeys.map((item, i) => {
      if (item && !item.status) {
        return (
          <div className="loaded-key" key={"loaded-key-"+i}>
            <button onClick={() => this.openModal(leaseId, item.marking)}>{item.marking}</button>
          </div>
        )
      }
    })
  }

  returnedKeys(transfer) {
    if (!this.props.receivedKeys || this.props.receivedKeys.length === 0) {return null}

    return (
      this.props.receivedKeys.map((item) => {
        let apartmentKeyOperations = ['remove', 'return', 'loose']
        let possibleErrors = ['is_busy', 'broken', 'lost']
        let abloyKeyOperations = ['remove_or_lost']

        if (item.state == 'returned') {
          abloyKeyOperations     = []
          apartmentKeyOperations = []
          possibleErrors         = []
        }

        return <KeyItem
          key={'key_stamp_out_' + item.id}
          abloyUpdatingMessageStatus={['IN_STOCK']}
          abloyKeyOperations={abloyKeyOperations}
          apartmentKeyOperations={apartmentKeyOperations}
          possibleErrors={possibleErrors}
          greenStatus={'returned'}
          item={item}
          lease={transfer.old_lease}
          inited={this.props.inited} />
      })
    )
  }

  lostKeys() {
    if (!this.props.lostKeys || this.props.lostKeys.length === 0) {return null}

    return (
      <div className="card-keys card-block">
        <p className="card-label">HÄVINNYT AVAIN</p>
        {this.props.lostKeys.map((item, i) => {
          return <LostKey key={'key_stamp_out_' + item.id} item={item} />
        })}
      </div>
    )
  }

  brokenKeys() {
    if (!this.props.brokenKeys || this.props.brokenKeys.length === 0) {return null}

    return (
      <div className="card-keys card-block">
        <p className="card-label">Broken keys</p>
        {this.props.brokenKeys.map((item, i) => {
          return <LostKey key={'key_stamp_out_' + item.id} item={item} />
        })}
      </div>
    )
  }

  confirmModal() {
    if (!this.state.modalIsOpen) return null;
    return (
      <ConfirmDialog
        modalIsOpen={this.state.modalIsOpen}
        confirm={this.confirm}
        closeModal={this.closeModal}
        text={"Oletko varma, että haluat lisätä tämän Abloyn avaimen sopimukseen?"}
      />
    )
  }

  /* methods */
  openModal(leaseId, marking) {
    this.setState({params: {leaseId, marking}});
    this.setState({modalIsOpen: true});
  };

  closeModal = () => {
    this.setState({modalIsOpen: false});
  };

  confirm = () => {
    const { leaseId, marking } = this.state.params;
    this.addKey(leaseId, marking);
    this.setState({modalIsOpen: false});
  };

  addKey(leaseId, marking) {
    this.setState({abloyLoaded: false});
    const self = this;
    this.props.addLeaseKey(leaseId, marking, false)
      .then(()=>{
        self.setState({abloyLoaded: true});
      })
  }

  render() {
    if (!this.props.transfer.old_lease) {
      return (<div className="card-transfer"></div>);
    }
    const transfer = this.props.transfer;

    return (
      <div className="card-transfer">
        {/* header */}
        {this.cardHeader()}
        <TransferCardHeader
          customers={transfer.old_lease.primary_customers}
          date={transfer.old_lease.due_to_terminate_on}
          leaseType='moving_out'
          finalInspectionDoneAt={transfer.final_inspection_done_at}
          finalInspectionNeedsRechecking={transfer.final_inspection_needs_rechecking}
          showInspectionCardStatus={true} />
        {/* load keys */}
        <div className="card-keys load-keys">
          {this.loadedAbloyKeys()}
        </div>
        {/* return keys */}
        <div className="card-keys card-block">
          <p className="card-label">PALAUTA AVAIMET</p>
          {this.returnedKeys(transfer)}
        </div>
        {/* lost keys */}
        {this.lostKeys()}
        {this.brokenKeys()}
        {this.confirmModal()}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TransferOutCard)
